/**
 * @generated SignedSource<<dc33cc6cf8b257c80a31f0f5906dc3bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedContactDealerButton_item";
};
export type PdpSharedContactDealerButton_item$key = {
  readonly " $data"?: PdpSharedContactDealerButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7c677a2f77eb61fc77fbd1a29f460f4a";

export default node;
